import React from 'react';

import {
  Home
} from './home';

function App() {
  return (
    <React.Fragment>
      <Home />
    </React.Fragment>
  );
}

export default App;